import SanityBlockContent from '@sanity/block-content-to-react';
import React from 'react';

export default function TextBlockInfo({ data }) {
  return (
    <>
      {data.nom && (
        <>
          <p>{data.nom && `Nom / ${data.nom}`}</p>
          <p>{data.email && `Email / ${data.email}`}</p>
          <p>{data.tel && `Téléphone / ${data.tel}`}</p>
          <p>Adresse / 3 rue Antoine Vollon 75012 Paris</p>
        </>
      )}

      {data._rawBio && (
        <SanityBlockContent
          blocks={data._rawBio}
          projectId="53zz037m"
          dataset="production"
        />
      )}
      {data._rawCv && (
        <SanityBlockContent
          blocks={data._rawCv}
          projectId="53zz037m"
          dataset="production"
        />
      )}
      {data._rawColophon && (
        <SanityBlockContent
          blocks={data._rawColophon}
          projectId="53zz037m"
          dataset="production"
        />
      )}
    </>
  );
}
